/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Nochange2Inputs */

const id_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada perubahan`)
};

const ms_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada perubahan`)
};

const da_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ændring`)
};

const de_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Änderung`)
};

const en_us2_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No change`)
};

const es_es2_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin cambios`)
};

const es_mx2_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin cambios`)
};

const fil_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang pagbabago`)
};

const fr_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun changement`)
};

const it_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun cambiamento`)
};

const hu_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs változás`)
};

const nl_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen verandering`)
};

const no_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen endring`)
};

const pl_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez zmian`)
};

const pt_br2_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem alteração`)
};

const pt_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem alteração`)
};

const ro_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fără modificare`)
};

const fi_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei muutosta`)
};

const sv_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen förändring`)
};

const vi_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thay đổi`)
};

const tr_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik yok`)
};

const cs_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez změny`)
};

const bg_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без промяна`)
};

const ru_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без изменений`)
};

const uk_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без змін`)
};

const ar_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد تغيير`)
};

const hi_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई बदलाव नहीं`)
};

const th_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่เปลี่ยนแปลง`)
};

const ja_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変化なし`)
};

const zh_cn2_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无变化`)
};

const zh_hant1_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無變化`)
};

const ko_components_performancetable_nochange2 = /** @type {(inputs: Components_Performancetable_Nochange2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변동 없음`)
};

/**
* | output |
* | --- |
* | "No change" |
*
* @param {Components_Performancetable_Nochange2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_nochange2 = /** @type {((inputs?: Components_Performancetable_Nochange2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Nochange2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_nochange2(inputs)
	if (locale === "ms") return ms_components_performancetable_nochange2(inputs)
	if (locale === "da") return da_components_performancetable_nochange2(inputs)
	if (locale === "de") return de_components_performancetable_nochange2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_nochange2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_nochange2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_nochange2(inputs)
	if (locale === "fil") return fil_components_performancetable_nochange2(inputs)
	if (locale === "fr") return fr_components_performancetable_nochange2(inputs)
	if (locale === "it") return it_components_performancetable_nochange2(inputs)
	if (locale === "hu") return hu_components_performancetable_nochange2(inputs)
	if (locale === "nl") return nl_components_performancetable_nochange2(inputs)
	if (locale === "no") return no_components_performancetable_nochange2(inputs)
	if (locale === "pl") return pl_components_performancetable_nochange2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_nochange2(inputs)
	if (locale === "pt") return pt_components_performancetable_nochange2(inputs)
	if (locale === "ro") return ro_components_performancetable_nochange2(inputs)
	if (locale === "fi") return fi_components_performancetable_nochange2(inputs)
	if (locale === "sv") return sv_components_performancetable_nochange2(inputs)
	if (locale === "vi") return vi_components_performancetable_nochange2(inputs)
	if (locale === "tr") return tr_components_performancetable_nochange2(inputs)
	if (locale === "cs") return cs_components_performancetable_nochange2(inputs)
	if (locale === "bg") return bg_components_performancetable_nochange2(inputs)
	if (locale === "ru") return ru_components_performancetable_nochange2(inputs)
	if (locale === "uk") return uk_components_performancetable_nochange2(inputs)
	if (locale === "ar") return ar_components_performancetable_nochange2(inputs)
	if (locale === "hi") return hi_components_performancetable_nochange2(inputs)
	if (locale === "th") return th_components_performancetable_nochange2(inputs)
	if (locale === "ja") return ja_components_performancetable_nochange2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_nochange2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_nochange2(inputs)
	return ko_components_performancetable_nochange2(inputs)
});
export { components_performancetable_nochange2 as "components.performanceTable.noChange" }